/**
 * Profile/session localStorage writes — kept separate from analytics so
 * PostHog identify cannot gate authentication/profile caching.
 */

export function writeCachedProfile(profile = {}) {
  localStorage.setItem('userId', profile.id || '');
  localStorage.setItem('userEmail', profile.email || '');
  localStorage.setItem('userName', profile.name || '');
  localStorage.setItem('userPicture', profile.picture || '');
  localStorage.setItem('userRole', profile.role || 'user');
  return Boolean(profile.id);
}
